import { ChangeEvent } from 'react'
import { Box, FormControlLabel, Switch } from '@mui/material'
import { SxProps } from '@mui/system'
import { useField, useFormikContext } from 'formik'
import { TooltipInfo, TootltipInfoType } from 'src/components/shared/ui/TooltipInfo'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { theme } from 'src/providers/ThemeProvider'

type StylesType = {
  formControlLabel: SxProps
}

export const styles: StylesType = {
  formControlLabel: {
    margin: 0,

    '& .MuiFormControlLabel-label': {
      lineHeight: '20px',
      margin: '0 8px',
      color: theme.colors.gray14
    }
  }
}

type Props = {
  id: string
  label?: string
  disabled?: boolean
  tooltipInfo?: TootltipInfoType
  onChange?: (value: boolean, e: ChangeEvent<HTMLInputElement>) => void
  sx?: SxProps
  valueOn?: string | boolean
  valueOff?: string | boolean
}

function SwitchField({
  id,
  label = '',
  disabled = false,
  tooltipInfo,
  onChange,
  sx,
  valueOn = true,
  valueOff = false
}: Props): JSX.Element {
  const { setFieldValue } = useFormikContext<EscritosFormValues>()
  const [fieldInfo] = useField(id)

  return (
    <Box display="flex" alignItems="center" sx={sx}>
      <FormControlLabel
        sx={styles.formControlLabel}
        control={
          <Switch
            disabled={disabled}
            checked={fieldInfo.value === valueOn || false}
            id={id}
            onChange={(e, value) => {
              if (onChange) {
                onChange(value, e)
              }
              setFieldValue(id, value ? valueOn : valueOff, false)
            }}
            onBlur={fieldInfo.onBlur}
            value={fieldInfo.value === valueOn}
          />
        }
        label={label}
      />
      {tooltipInfo && <TooltipInfo tooltipInfo={tooltipInfo} />}
    </Box>
  )
}

export default SwitchField
